/* global VeloxViewController */
var pkg = require("../../../package.json") ;

var DownloadController = VeloxViewController.create({
    directory : "views/login",
    name: "download",
    container: "main",
    route: "download"
}) ;

DownloadController.prototype.prepareDataOnEnter = function(token, callback){
    //normal login
    var filename = "Hydratest%20Setup%20" ;
    if(process.env.MODE === "test"){
        filename = "Hydratest%20Test%20Setup%20" ;
    }

    var baseUrl = pkg.serverUrl ;

    if(process.env.MODE !== "production"){
        baseUrl = pkg.serverDev ;
        if(process.env.MODE === "test"){
            baseUrl = pkg.serverTest ;
        } else {
            if(process.env.DEVICE === "mobile"){
                baseUrl = pkg.serverDevMobile ;
            }
        }
    }

    callback(null, {
        url: baseUrl+"/updates/"+filename+pkg.version+".exe" 
    });
};

module.exports = new DownloadController() ;